import { FC } from 'react'
import { SectionAccordionProps } from '@portfolio/models'
import { styled } from '@portfolio/styles'
import {
  Accordion,
  AccordionItem,
  AccordionTrigger,
  AccordionContent,
  PortableText,
  SectionWrapper,
  isLinkAction,
} from '@portfolio/components'
import { Link } from '@portfolio/components'

export const SectionAccordion: FC<SectionAccordionProps> = ({
  title,
  actionLabel,
  action,
  faqs,
  spacing,
  topBorder,
}) => {
  const isFaqsPresent = faqs && faqs.length > 0
  return (
    <FaqSection type={spacing || 'MEDIUM'} topBorder={topBorder}>
      <FaqSectionTitleWrapper>
        <FaqSectionTitle>{title}</FaqSectionTitle>
        <FaqSectionAction>
          {actionLabel !== null && action && isLinkAction(action) && (
            <Link {...action} appearance="containedTransparent">
              {actionLabel}
            </Link>
          )}
        </FaqSectionAction>
      </FaqSectionTitleWrapper>
      <AccordionWrapper>
        <Accordion>
          {isFaqsPresent &&
            faqs.map((faq, index) => {
              if (!faq.question) return null

              // The first divider is only displayed if topBorder is false
              const displayDivider = index !== 0 || !topBorder

              return (
                <AccordionItem
                  key={index}
                  value={index.toString()}
                  isDivider={displayDivider}
                >
                  <AccordionTrigger>{faq.question}</AccordionTrigger>
                  <AccordionContent>
                    <PortableText value={faq.answer} appearance="faq" />
                  </AccordionContent>
                </AccordionItem>
              )
            })}
        </Accordion>
      </AccordionWrapper>
    </FaqSection>
  )
}

const FaqSection = styled(SectionWrapper, {
  paddingInline: 20,

  '@lg': {
    display: 'grid',
    paddingInline: 30,
    maxWidth: '$maxWidthDesktop',
    marginInline: 'auto',
    gridTemplateColumns: '1fr 1.5fr',
    gap: 30,
  },
})

const FaqSectionTitle = styled('h2', {
  paddingBlockEnd: 56,
  projectFont: 'heading04',
  color: '$white',

  '@lg': {
    paddingBlockEnd: 0,
    maxWidth: 430,
  },
})

const FaqSectionAction = styled('div', {
  display: 'none',

  '@lg': {
    display: 'block',
  },
})

const FaqSectionTitleWrapper = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  gap: 32,
  alignItems: 'flex-start',
})

const AccordionWrapper = styled('div', {
  '@lg': {
    gridColumn: 2,
    width: '100%',
    maxWidth: 1080,
  },
})
